import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var UpdateVendersRes;
export const UpdateVendersTodo = createAsyncThunk('UpdateVenders', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL + 'vendor_details',
            data: data ,
            headers: { "Content-Type": "multipart/form-data" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdateVendersRes = res.data
        
    } catch (error) {
        return UpdateVendersRes = error.response.data
    }
})
